import { Disclosure } from "@headlessui/react";
import React, { FC } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

interface ExpandButtonProps {
  label?: string;
  isOpen?: boolean;
  keepOpen?: boolean;
}

const ExpandButton: FC<ExpandButtonProps> = ({
  label,
  isOpen = false,
  keepOpen = false,
  children,
}) => {
  return (
    <Disclosure.Button
      as="div"
      className={`flex flex-row items-center justify-between w-full py-4 text-white text-opacity-64 focus:outline-none focus-visible:ring focus-visible:ring-opacity-75 bg-transparent cursor-pointer ${
        keepOpen && isOpen && "pointer-events-none"
      }`}
      style={{ WebkitAppearance: "none" }}
    >
      <div className="flex flex-row w-full">
        <p className="responsive-h3 md:responsive-h2">{label}</p>
      </div>
      <div
        className={`flex flex-row space-x-16 items-center ${
          keepOpen && isOpen && "hidden"
        }`}
      >
        {children}
        <div
          className={`${
            isOpen ? "" : "-rotate-180"
          } transform transition-transform duration-300 ease-in-out flex border rounded-full h-32 w-32 opacity-64 items-center`}
        >
          <ExpandLessIcon className="w-24 h-24 fill-current text-white mx-auto" />
        </div>
      </div>
    </Disclosure.Button>
  );
};

export default ExpandButton;
